import {getCookieVal} from "./Cookie.js";

/**
 * Open "yellow" notification window with due tasks
 * @param {string} windowName	name of the window
 * @param {boolean} focus		should be the window brought to the front
 */
export function openNotifyWindow(windowName, focus)
{
	let width = 640;
	let height = getCookieVal('notification_H');
	if(!height) height=320;
	let scrX = getCookieVal('notification_X');
	if(!scrX) scrX=20;
	let scrY = getCookieVal('notification_Y');
	if(!scrY) scrY=50;

	const okno = window.top.open('notifyGroupDialog.do', windowName, 'directories=no,height='+height+',width='+width+',location=no,menubar=no,resizable=yes,scrollbars=yes,status=no,toolbar=no,left='+scrX+',top='+scrY);
	if (okno != null) okno.location.replace('notifyGroupDialog.do');
	if (focus && okno != null) okno.focus();
}


/**
 * Open all notifications in standalone windows
 * @param {number[]} notifications	array of server IDs of notifications
 */
export function openNotifications(notifications)
{
	for (let notId of notifications) {
		openIfNot("notify"+notId, "notifyDialog.do?id="+notId);
	}
}

/**
 * Open one notification window
 * @param {string} windowName	name of the window
 * @param {string} notifyLink	URL of the content
 */
function openIfNot(windowName, notifyLink)
{
	// check if it is open
	const okno = window.top.open(notifyLink, windowName, 'directories=no,height=300,width=450,location=no,menubar=no,resizable=no,scrollbars=yes,status=no,toolbar=no');
	if(okno!=null) okno.location.replace(notifyLink);
}

/**
 * Open alert window
 * @param {number} alertId		server ID (AlertMessage) of the alert
 */
export function openAlertWindow(alertId) {
	window.top.open('showAlert.do?id='+alertId, 'AlertMessage_'+alertId, 'directories=no,height=300,width=400,directories=no,location=no,menubar=no,resizable=yes,scrollbars=yes,status=no,toolbar=no');
}
